<template>
  <div class="flex-child">
    <div class="vue-chart">
      <el-skeleton :loading="isLoadingUpdateDataDashboardInjected" animated>
        <template #template>
          <el-skeleton-item style="height: 315px" />
        </template>
        <template #default>
          <apexchart width="100%" height="300" type="pie" :options="chartOptions" :series="series" />
        </template>
      </el-skeleton>
    </div>

    <div class="flex-text">
      <p v-html="$t('dashboardLocked', { label: formatters.label.call(currentTokenInfo?.name) })"></p>
      <p
        v-html="$t('dashboardAvailableForPurchaseAmount', { label: formatters.label.call(currentTokenInfo?.name) })"
      ></p>
      <p v-html="$t('dashboardUnlocked', { label: formatters.label.call(currentTokenInfo?.name) })"></p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ChartDataFormatterProps } from '~/types/common';
import { Tokens } from '~/utils/constants';
import type { ITokenModel } from '~/types/apiService';
import { colors } from '~/utils/constants/charts';

const { t } = useI18n();
const store = useMainStore();

const { data: currentTokenInfo } = useNuxtData<ITokenModel>('dashboardCurrentTokenInfo');

const isLoadingUpdateDataDashboardInjected = inject<Ref<boolean>>('isLoadingUpdateDataDashboard');
const saleAmountInjected = inject<Ref<number>>('saleAmountValue', ref(0));
const totalStakedInjected = inject<Ref<number>>('totalStaked', ref(0));
const unstakedInjected = inject<Ref<number>>('unstaked', ref(0));

const props = defineProps<ChartDataFormatterProps>();

const labels = computed(() => [
  t('dashboardLockedLabel'),
  t('dashboardAvailableForPurchaseLabel'),
  t('dashboardUnlockedLabel')
]);

const series = computed(() => {
  if (store.currentToken === Tokens.pearl) {
    return [totalStakedInjected.value, saleAmountInjected.value, unstakedInjected.value];
  }

  return [];
});

const chartOptions = computed(() => ({
  theme: {
    mode: 'dark'
  },
  chart: {
    class: 'vuechart-example',
    background: '#00000000'
  },
  labels: labels.value,
  title: {
    text: t('coreLocking'),
    align: 'center',
    style: {
      fontSize: '24px'
    }
  },
  legend: {
    fontSize: '12px',
    offsetY: 30
  },
  stroke: {
    width: 0
  },
  ...colors,
  tooltip: {
    y: {
      formatter: function (val: number) {
        return props.formatters.tooltip.call(val);
      }
    },
    fillSeriesColor: true
  },
  responsive: [
    {
      breakpoint: 600,
      options: {
        legend: {
          position: 'bottom',
          offsetY: 0
        },
        chart: {
          height: 500
        }
      }
    }
  ]
}));
</script>

<style lang="scss" scoped>
.vue-chart {
  min-height: 340px;
}
</style>
